import { eSystemModule } from "@hub/generated/enums";
import { ApiSettings } from "@hub/generated/apiSettings";

export class MenuItem {
    constructor(
      label: string,
      icon: string,
      roles: boolean,
      order: number,
      isVisible: boolean,
      routerLink?: string[],
      items?: MenuItem[],
      modules?: eSystemModule[]
    ) {
        this.Label = label;
        this.Icon = icon;
        this.Roles = roles;
        this.Order = order;
        this.IsVisible = isVisible;
        this.RouterLink = routerLink;
        this.Modules = modules;
        if (items) {
            this.Items = items;
        }
    }

    public Label: string;
    public Icon: string;
    public Roles: boolean;
    public Order: number;
    public RouterLink?: string[];
    public IsVisible: boolean = false;
    public Modules: eSystemModule[];
    public hasChild: boolean;
    private _items?: MenuItem[] = [];

    public get Items(): MenuItem[] {
      return this._items;
    }
    public set Items(items: MenuItem[]) {
       this._items = items;
       this.hasChild = items && items.length > 0;
    }
}
